export default {
  title: 'global.titles.welcome',
  signIn: 'components.views.login-view.sign-in',
  email: 'global.account.email',
  password: 'global.account.password',
  login: 'components.views.login-view.login',
  forgotPassword: 'global.account.forgot-password',
  resetPassword: 'global.account.reset-password'
}
